<button (click)="close()" class="modal-close" inlineSVG="/assets/icons/close.svg"></button>
<h1 *ngIf="!edit" class="modal-title">Add Member</h1>

<ng-container *ngIf="edit">
  <h1 class="modal-title">Edit Member</h1>
</ng-container>

<fl-message-box [type]="MessageBoxType.Info" [messages]="messages"></fl-message-box>

<form autocomplete="off" #form="ngForm">
  <div class="entity-member-select-roles" *ngIf="enableMemberSelectRoles && data.entityMemberRoles?.length">
    <h5>Select Role(s)</h5>
    <fieldset class="select-roles">
      <label *ngFor="let role of data.entityMemberRoles" [class.disabled]="(data.primaryContact && role === entityMemberRoleType.Viewer) || role === entityMemberRoleType.Owner">
        <mat-checkbox
          (ngModelChange)="entityMemberRoleSelections.set(role, $event)"
          [name]="role"
          [ngModel]="entityMemberRoleSelections.get(role)"
          [disabled]="(data.primaryContact && role === entityMemberRoleType.Viewer) || role === entityMemberRoleType.Owner"
        ></mat-checkbox>
        <span class="checkbox-label-text">{{entityMemberTypeLabels[role]}}</span>
      </label>
    </fieldset>
  </div>

  <label class="half-width">
    First Name*
    <mat-form-field appearance="outline" floatLabel="always">
      <input
        matInput
        [(ngModel)]="member.first_name"
        [disabled]="edit"
        [placeholder]="firstName || 'Enter first name'"
        [required]="!edit"
        name="first_name"
        type="text"
      />
    </mat-form-field>
  </label>

  <label class="half-width">
    Last Name*
    <mat-form-field appearance="outline" floatLabel="always">
      <input
        matInput
        [(ngModel)]="member.last_name"
        [disabled]="edit"
        [placeholder]="lastName || 'Enter last name'"
        [required]="!edit"
        name="last_name"
        type="text"
      />
    </mat-form-field>
  </label>

  <label class="half-width">
    Title
    <mat-form-field appearance="outline" floatLabel="always">
      <input matInput
        [(ngModel)]="member.title"
        [placeholder]="title || 'Enter title'"
        name="title"
        type="text"
      />
    </mat-form-field>
  </label>

  <label class="half-width">
    Email*
    <mat-form-field appearance="outline" floatLabel="always">
      <input
        matInput
        [(ngModel)]="member.email"
        [disabled]="edit"
        [pattern]="inputEmailPattern"
        [placeholder]="email || 'Enter email'"
        [required]="!edit"
        name="email"
        type="email"
      />
    </mat-form-field>
  </label>

  <div class="communication-preferences" *ngIf="data.enableCommunicationPreferences">
    <h2 class="modal-sub-heading">Communications</h2>
    <p *ngIf="!(currentMember | isPrimaryContact); else primaryText">
      Select the types of communications that this member will recieve notifications about.
    </p>
    <ng-template #primaryText>
      <p>A primary contact will always recieve all communication types.</p>
    </ng-template>

    <fl-message-communication-types
      [disabled]="currentMember | isPrimaryContact"
      [(communicationTypes)]="member.communication_types"
    ></fl-message-communication-types>
  </div>


  <ng-container *ngIf="!edit">
    <mat-slide-toggle color="primary" name="send_email" [(ngModel)]="sendEmail">
      Notify via email
      <p>Enabling this will send an email to the new member.</p>
    </mat-slide-toggle>
  </ng-container>

  <button (click)="close()" class="cancel" type="button">Cancel</button>
  <button *ngIf="edit" (click)="editMember(form)" class="submit" type="submit" [disabled]="!form.valid">
    Save
  </button>

  <button *ngIf="!edit" (click)="addMember(form)" class="submit" type="submit" [disabled]="!form.valid">
    Add Member
  </button>
</form>
